import FormattedNumber from '../_components/formattedNumber';

const AssessmentTab = ({ assessment }) => {
  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '10px',
    fontSize: '15px',
    color: '#000000',
  };

  const valueStyle = {
    fontSize: '15px',
    fontWeight: 'normal',
    color: '#000000',
  };

  return (
    <div>
      <div
        className='assessment-container'
        style={{ display: 'flex', gap: '30px', padding: '20px 0' }}
      >
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={labelStyle}>Periodic Installment</div>
          <div style={valueStyle}>
            $
            <FormattedNumber
              decimalScale={2}
              value={assessment.periodicInstallment || 0}
            />
          </div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={labelStyle}>Annual Assessment</div>
          <div style={valueStyle}>
            $
            <FormattedNumber
              decimalScale={2}
              value={assessment.annualAssessment || 0}
            />
          </div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={labelStyle}>Total Assessment</div>
          <div style={valueStyle}>
            $
            <FormattedNumber
              decimalScale={2}
              value={assessment.totalAssessment || 0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentTab;
